import { render } from "./Congres.vue?vue&type=template&id=77f12d00"
import script from "./Congres.vue?vue&type=script&lang=js"
export * from "./Congres.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__